<template>
  <div>
    <div
      style="
        border: 1px solid #707070;
        border-radius: 20px;
        padding: 5px;
        display: flex;
        align-items: center;
        cursor: pointer;
      "
      @click="modalShow = !modalShow"
    >
      <span class="material-symbols-outlined"> barcode_scanner </span>
    </div>
    <b-modal v-model="modalShow" hide-footer>
      <!-- <b-form-select v-model="camera">
        <b-form-select-option :value="null"
          >Please select Device</b-form-select-option
        >
        <b-form-select-option
          v-for="device in devices"
          :key="device.deviceId"
          :value="device.label"
          >{{ device.label }}</b-form-select-option
        >
      </b-form-select> -->
      <!-- <b-button variant="primary" pill @click="switchCamera">
        <span class="material-icons-outlined"> cameraswitch </span>
        </b-button> -->
      <!-- <p>camera : {{ camera }}</p> -->
      <p class="decode-result">
        Last result: <b>{{ result }}</b>
      </p>

      <qrcode-stream :camera="camera" @decode="onDecode" @init="onInit" :track="paintOutline">
        <div v-show="showScanConfirmation" class="scan-confirmation"></div>
        <b-button variant="primary" pill @click="switchCamera">
        <span class="material-icons-outlined"> cameraswitch </span>
        </b-button>
      </qrcode-stream>
    </b-modal>
  </div>
</template>

<script>
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from "vue-qrcode-reader";
import { WebCam } from "vue-web-cam";
import useSound from "vue-use-sound";
import buttonSfx from "@/assets/images/Unicorn/scan.mp3";

export default {
  components: {
    QrcodeStream,
    QrcodeDropZone,
    QrcodeCapture,
    "vue-web-cam": WebCam,
  },
  data() {
    return {
      modalShow: false,
      camera: null,
      result: null,
      showScanConfirmation: false,
      deviceId: null,
      devices: [],
    };
  },
  computed: {
    device() {
      return find(this.devices, (n) => n.deviceId == this.deviceId);
    },
  },
  setup() {
    const [play] = useSound(buttonSfx);

    return {
      play,
    };
  },
  async mounted() {
    try {
      if (
        "mediaDevices" in navigator &&
        "getUserMedia" in navigator.mediaDevices
      ) {
        // ok, browser supports it
        // const videoStream = await navigator.mediaDevices.getUserMedia({
        //   video: true,
        // });
        // navigator.mediaDevices.enumerateDevices()
        // this.getLocalStream()
        this.devices = await this.getCamera();
      }
    } catch (error) {
      console.error(error);
    }
  },
  methods: {
    switchCamera() {
      switch (this.camera) {
        case "front":
          this.camera = "rear";
          break;
        case "rear":
          this.camera = "front";
          break;
        default:
          this.camera = "rear";
          break;
      }
    },

    async onInit(promise) {
      try {
        await promise;
      } catch (e) {
        console.error(e);
      } finally {
        this.showScanConfirmation = this.camera === "off";
      }
    },

    async getCamera() {
      let camera_list = navigator.mediaDevices
        .enumerateDevices()
        .then(function (devices) {
          console.log(devices);
          let camera = [];
          for (var i = 0; i < devices.length; i++) {
            var device = devices[i];
            if (device.kind === "videoinput") {
              camera.push({
                deviceId: device.deviceId,
                label: device.label,
              });
            }
          }
          console.log(camera);
          return camera;
        });

      return camera_list;
    },

    async onDecode(content) {
      console.log(content);
      this.result = content;
      this.play();
      this.$emit('update-tag',content)
      this.modalShow = false
    },

    getLocalStream() {
      navigator.mediaDevices
        .getUserMedia({ video: true, audio: false })
        .then((stream) => {
          window.localStream = stream; // A
          window.localAudio.srcObject = stream; // B
          window.localAudio.autoplay = true; // C
        })
        .catch((err) => {
          console.error(`you got an error: ${err}`);
        });
    },
    paintOutline (detectedCodes, ctx) {
      for (const detectedCode of detectedCodes) {
        const [ firstPoint, ...otherPoints ] = detectedCode.cornerPoints

        ctx.strokeStyle = "red";

        ctx.beginPath();
        ctx.moveTo(firstPoint.x, firstPoint.y);
        for (const { x, y } of otherPoints) {
          ctx.lineTo(x, y);
        }
        ctx.lineTo(firstPoint.x, firstPoint.y);
        ctx.closePath();
        ctx.stroke();
      }
    },
  },
  watch: {
    camera: function (id) {
      this.deviceId = id;
    },
    devices: function () {
      // Once we have a list select the first one
      let first = head(this.devices);
      if (first) {
        this.camera = first.deviceId;
        this.deviceId = first.deviceId;
      }
    },
  },
};
</script>

<style>
</style>